import React from 'react';
import { Card, Badge, Btn, Divider, BottomNav, StarIcon, LockIcon, SignOutIcon, ArrowRightIcon, TronzaxLogo } from '../components/SharedComponents';
import C from '../styles/tokens';

const Account = ({ navigate }) => (
  <div className="page-wrapper fade-in">

    {/* ── Account Hero ── */}
    <div className="account-hero">
      <div className="flex gap-14 items-center">
        <div className="account-avatar">J</div>
        <div>
          <div style={{ color: '#fff', fontWeight: 800, fontSize: 18 }}>John Doe</div>
          <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13 }}>johndoe@gmail.com</div>
          <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>+91 9876543210</div>
        </div>
      </div>
      <div>
        <Badge color="#fff" bg="rgba(255,255,255,0.2)">● Active</Badge>
        <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 11, marginTop: 4 }}>
          Member since Feb 2026
        </div>
      </div>
    </div>

    {/* ── Content ── */}
    <div className="page-content">

      {/* Security & Access */}
      <Card style={{ marginBottom: 14 }}>
        <div className="flex items-center gap-8 mb-12" style={{ fontWeight: 700, fontSize: 14, color: C.textPrimary }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={C.primary} strokeWidth="2">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          </svg>
          Security &amp; Access
        </div>

        {[
          { label: 'User ID',     val: 'TZX82973',         mono: true },
          { label: 'Last Login',  val: 'Today, 11:32 AM' },
          { label: 'Last Active', val: 'Today, 11:32 AM' },
        ].map((row, i) => (
          <div key={i}>
            {i > 0 && <Divider />}
            <div className="flex justify-between items-center" style={{ padding: '8px 0' }}>
              <span style={{ fontSize: 13, color: C.textMuted }}>{row.label}</span>
              <span style={{
                fontWeight: 700, fontSize: 13, color: C.textPrimary,
                fontFamily: row.mono ? 'Space Mono, monospace' : 'Nunito, sans-serif',
              }}>
                {row.val}
              </span>
            </div>
          </div>
        ))}

        <Divider />
        <button style={{
          marginTop: 10, background: 'none', border: 'none', color: C.primary,
          fontWeight: 700, fontSize: 14, cursor: 'pointer', fontFamily: 'Nunito, sans-serif',
          display: 'flex', alignItems: 'center', gap: 6,
        }}>
          <LockIcon />
          Change Password ›
        </button>
        <div style={{ marginTop: 6, fontSize: 11, color: C.textMuted }}>
          Share your User ID when contacting support
        </div>
      </Card>

      {/* Limits */}
      <Card style={{ marginBottom: 14 }}>
        <div className="flex items-center gap-8 mb-12" style={{ fontWeight: 700, fontSize: 14, color: C.textPrimary }}>
          <StarIcon />
          Limits
        </div>
        <div className="flex justify-between items-center mb-8">
          <span style={{ fontSize: 13, color: C.textMuted }}>Monthly Limit</span>
          <span className="font-mono" style={{ fontWeight: 800, fontSize: 15, color: C.textPrimary }}>
            1,00,000 USDT
          </span>
        </div>
        <div className="progress-bar-track">
          <div className="progress-bar-fill" style={{ width: '0.5%' }} />
        </div>
        <div className="flex justify-between mt-8">
          <span style={{ fontSize: 11, color: C.textMuted }}>Resets on 1 March 2026</span>
          <button style={{
            background: 'none', border: 'none', color: C.primary,
            fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: 'Nunito, sans-serif',
          }}>
            View Details ›
          </button>
        </div>
      </Card>

      {/* Transaction History */}
      <Card style={{ marginBottom: 14 }}>
        <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 4, color: C.textPrimary }}>
          Transaction History
        </div>
        {[
          { label: 'Buy History',      icon: '↑', color: C.accent,   onClick: () => navigate('buy') },
          { label: 'Withdraw History', icon: '↓', color: C.primary,  onClick: () => navigate('withdraw') },
        ].map((item, i) => (
          <div key={i}>
            {i > 0 && <Divider />}
            <button className="history-row-btn" onClick={item.onClick}>
              <div className="flex gap-10 items-center">
                <div className="history-icon" style={{ background: `${item.color}18`, color: item.color }}>
                  {item.icon}
                </div>
                <span style={{ fontWeight: 700, fontSize: 14, color: C.textPrimary }}>
                  {item.label}
                </span>
              </div>
              <ArrowRightIcon />
            </button>
          </div>
        ))}
      </Card>

      {/* Support */}
      <Card style={{ marginBottom: 16 }}>
        <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 12, color: C.textPrimary }}>
          Support
        </div>
        <div style={{
          background: `${C.accent}10`, borderRadius: 12,
          padding: '14px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        }}>
          <div>
            <div style={{ fontWeight: 700, fontSize: 14, color: C.textPrimary }}>
              Contact us on WhatsApp
            </div>
            <div style={{ fontSize: 12, color: C.textMuted }}>
              +91 9876543210 • Under 10 min response
            </div>
          </div>
          <Btn onClick={() => {}} variant="success" size="sm">Chat Now</Btn>
        </div>
      </Card>

      {/* Footer */}
      <div className="flex justify-between" style={{ padding: '0 4px', marginBottom: 8 }}>
        <span style={{ fontSize: 11, color: C.textMuted }}>App Version 1.0.0</span>
        <span style={{ fontSize: 11, color: C.accent, fontWeight: 600 }}>● Secure Session Active</span>
      </div>

      {/* Sign Out */}
      <Btn
        onClick={() => {}}
        variant="danger" full size="md"
        icon={<SignOutIcon />}
      >
        Sign Out
      </Btn>
    </div>

    <BottomNav active="account" navigate={navigate} />
  </div>
);

export default Account;
